import React from 'react';
import {connect} from 'react-redux';

import AudioPlayer from '../../components/AudioPlayer';

import strings from '../../utils/strings';
import previewVideoNo from './assets/e845140cdea968bfb0a8144fb06a7064.mp4';
import previewVideoNn from './assets/e845140cdea968bfb0a8144fb06a7064.mp4';

import previewVideoSe from './assets/se_ordforståelse.mp4';
import previewVideoDe from './assets/DE_Ordforståelse.mp4';

import {VARIATION} from '../../constants';

class Intro extends React.Component {
	constructor() {
		super();
		const variation = VARIATION;
		const language = strings.getLanguage();
		const previewVideoObj = {
			no: previewVideoNo,
			nn: previewVideoNn,
			se: previewVideoSe,
			de: previewVideoDe,
		};
		this.state={
			showStartBtn:false,
		};
		this.audio = require(`../../assets/sounds/${variation}/${language}/swscrc4-1.mp3`);
		this.video = previewVideoObj[language];
		this.videoRefView = React.createRef();
		this.buttonRefView = React.createRef();
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div>
				<div className="text-left">
					<p>
						<AudioPlayer
							autoplay
							inline
							onStart={() => {
								const scrollActionTime =
									this.currentLang === 'se' ? 18000 : 31000;
	
								if (scrollActionTime) {
									setTimeout(() => {
										if (this.videoRefView.current) {
											this.videoRefView.current.scrollIntoView(
												{
													behavior: 'smooth',
													block: 'start',
												}
											);
											videoRef.play();
										}
									}, scrollActionTime);
								}
							}}
							onPause={() => {
								videoRef.play();
							}}
							onComplete={() => {
								this.setState({
											
									showStartBtn:true
								});
								setTimeout(() => {
									
									this.buttonRefView.current.scrollIntoView({
										behavior: 'smooth',
									block: 'start',
									});
										
									}, 1000);
	
							}}
							src={this.audio}
						/>
						{strings.ordforstaelseIntro}
					</p>
					<br/>
					<p>{strings.ordforstaelseTimelimit}</p>
				</div>
				<div className="lit-preview" ref={this.videoRefView}>
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={this.video}
					/>
				</div>
				{this.state.showStartBtn && (
					<button ref={this.buttonRefView}
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
